import { render } from "./money_to_cashier_items.vue?vue&type=template&id=2bf6b5e2&scoped=true"
import script from "./money_to_cashier_items.vue?vue&type=script&lang=js"
export * from "./money_to_cashier_items.vue?vue&type=script&lang=js"

import "./money_to_cashier_items.vue?vue&type=style&index=0&id=2bf6b5e2&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf6b5e2"]])

export default __exports__